import type { TwetchIdentity } from './twetch-auth'

/**
 * The cached Twetch identity, but only if it belongs to the connected wallet.
 *
 * A wallet switch must never keep acting through the previous wallet's cached
 * session, and a logged-out visitor (no address) has no identity at all even
 * when one is still in storage. Three call sites used to inline this with
 * `address.toLowerCase()`, which threw on a null address and took the whole
 * alkane page down for anyone visiting logged out with a stale identity.
 */
export function identityForAddress(
	stored: TwetchIdentity | null | undefined,
	address: string | null | undefined
): TwetchIdentity | null {
	if (!stored || !address || typeof stored.address !== 'string') return null
	return stored.address.toLowerCase() === address.toLowerCase() ? stored : null
}
